import SolutionHeroI18n from "@/components/landing/shared/SolutionHeroI18n";
import { Megaphone, Target, Mail, Users, BarChart3, Sparkles } from "lucide-react";
import { UserCheck, TrendingUp } from "lucide-react";
import heroImage from "@/assets/hero-person-marketing.png";

const MarketingHero = () => (
  <SolutionHeroI18n
    translationPrefix="marketingSolution"
    heroImage={heroImage}
    floatingIcons={[
      { icon: Megaphone, position: "top-[5%] left-[5%]", delay: "0s", duration: "3s", color: "mint" },
      { icon: Target, position: "top-[5%] right-[5%]", delay: "0.5s", duration: "3.5s", color: "orange" },
      { icon: Mail, position: "top-[40%] -left-[8%]", delay: "1s", duration: "4s", color: "primary" },
      { icon: Users, position: "top-[30%] -right-[8%]", delay: "1.5s", duration: "3.2s", color: "mint" },
      { icon: BarChart3, position: "bottom-[10%] left-[5%]", delay: "0.7s", duration: "3.8s", color: "orange" },
      { icon: Sparkles, position: "bottom-[2%] right-[30%]", delay: "2s", duration: "3.6s", color: "primary" },
    ]}
    kpis={[
      { icon: UserCheck, labelKey: "kpiLeads", valueKey: "kpiLeadsValue", color: "text-chathero-mint" },
      { icon: Mail, labelKey: "kpiInteraction", valueKey: "kpiInteractionValue", color: "text-chathero-orange" },
      { icon: TrendingUp, labelKey: "kpiConversion", valueKey: "kpiConversionValue", color: "text-primary" },
    ]}
  />
);

export default MarketingHero;
